import { notice } from "JS/utils/notice";

export default class Coupon {
    /**
     * @type {HTMLElement}
     */
    couponContainer;

    /**
     * @type {HTMLElement}
     */
    orderReviewParent;

    /**
     * @type {HTMLElement}
     */
    orderReview;

    /**
     * @type {HTMLElement}
     */
    inputCode;

    /**
     * @type {HTMLElement}
     */
    inputNonce;

    /**
     * @type {Object}
     */
    checkout;

    constructor(checkout) {
        this.checkout = checkout;
        this.init();
    }

    init() {
        this.couponContainer = document.querySelector('.cart-payment__promo');
        if (!this.couponContainer) {
            return;
        }

        this.orderReviewParent = document.querySelector('.checkout-template__summary');
        this.orderReview = document.querySelector('#order_review');
        this.inputCode = this.couponContainer.querySelector('input[name="coupon_code"]');
        this.inputNonce = this.couponContainer.querySelector('#_coupon_nonce');
        this.btnSubmit = this.couponContainer.querySelector('[data-apply-coupon]');

        this.addListeners();
    }

    addListeners() {
        this.btnSubmit.addEventListener('click', (e) => {
            e.preventDefault();
            if (this.inputCode.value == '') {
                this.onError('Текст купона не должен быть пустым');
            } else {
                this.applyCoupon(); 
            }
            
        })
    
        Array.from(this.couponContainer.querySelectorAll('.woocommerce-remove-coupon')).forEach((el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                const code = el.dataset.coupon;
                this.removeCoupon(code);
            });
        });
    }

    removeCoupon(code) {
        if (!code) {
            return;
        }

        this.applyCoupon(code, true);
    }

    applyCoupon(code = null, remove = false) { 
        this.orderReviewParent.classList.add('loading');
        this.btnSubmit.classList.add('processing');

        const data = {
            '_coupon_nonce': this.inputNonce.value,
            'coupon_code': code ?? this.inputCode.value,
            'page': 'checkout',
            'remove': remove,
        }

        const formData = new FormData();
        formData.append('action', 'apply_coupon');
        formData.append('data', JSON.stringify(data));

        fetch(backendData.ajaxUrl, {
            method: 'POST',
            body: formData,
        })
            .then((resp) => resp.json())
            .then((response) => {
                if (!response.success) {
                    this.onError(response.data);
                    return;
                }

                const {
                    html,
                    message,
                    done,
                } = response.data;

                if (done) {
                    notice(message);
                } else {
                    this.onError(message);
                }
                if (html) {
                    this.orderReview.outerHTML = html;
                    this.init();
                    this.checkout.UsePoints.init();
                }
            })
            .catch((error) => {
                this.onError(error);
            })
            .finally(() => {
                this.orderReviewParent.classList.remove('loading');
                this.btnSubmit.classList.remove('processing');
            });
    }

    onError(error) {
        notice(error, 'error');
    }

}
